import OnboardTCManager from '../../features/marketingManager/OnboardTCManager'

const OnboardTCManagerPage = () => {
  return <OnboardTCManager />
}

export default OnboardTCManagerPage